module.exports = __webpack_public_path__ + "static/media/profile.347f14a1.png";